// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 514) return "static/chunks/514-ae3382d3573fde2b.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 343 ? "6edf0643" : chunkId) + "." + {"343":"d8a7c6b6bdcdfe66","977":"aab84f6c95445947","1940":"bd4e49a204d95559","5811":"e311fc2a662c65fe","6631":"5fb3cc08c12c85d9"}[chunkId] + ".js";
};